module.exports = __webpack_public_path__ + "static/media/stores.4adf72fa.svg";